import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { NonceProvider } from './utils/nonce-provider.ts'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

startTransition(() => {
	const nonce =
		document.querySelector<HTMLScriptElement>('script[nonce]')?.nonce ?? ''
	hydrateRoot(
		document,
		<NonceProvider value={nonce}>
			<HydratedRouter />
		</NonceProvider>,
	)
})
